import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faTiktok } from '@fortawesome/free-brands-svg-icons';
import { SYMBOL, INSTA, TIKTOK } from '../../constants';
import { ExternalLink } from '../ui';

const About = () => {
  return (
    <section id="sobre" className="py-12 sm:py-20 lg:py-28 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-goshine-navy/50 to-goshine-dark" />
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-16 items-center">
          {/* Content */}
          <div className="order-2 lg:order-1">
            <span className="text-goshine-orange font-semibold tracking-wider uppercase text-sm lg:text-base mb-3 lg:mb-4 block">
              Nossa História
            </span>
            
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-4 sm:mb-6 lg:mb-8">
              Da garagem ao <span className="gradient-text">sucesso</span>
            </h2>
            
            <div className="space-y-4 lg:space-y-5 text-gray-300 text-sm sm:text-base lg:text-lg leading-relaxed">
              <p>
                A <strong className="text-white">GoShine</strong> nasceu de um hobby entre amigos. 
                Marcelo começou lavando carros em uma garagem e percebeu o potencial de transformar essa paixão em negócio.
              </p>
              <p>
                No início, a solução criativa foi o <strong className="text-goshine-orange">atendimento delivery</strong> — 
                com uma van equipada. Os primeiros clientes foram difíceis, exigindo muita dedicação.
              </p>
              <p>
                Hoje, a GoShine conta com <strong className="text-white">quatro boxes cobertos</strong> e 
                oferece serviços premium: vitrificação, polimento e higienização com ozônio.
              </p>
            </div>

            {/* Social Links */}
            <div className="flex flex-wrap gap-3 mt-6">
              <ExternalLink 
                href={INSTA} 
                className="glass-effect px-4 py-2.5 flex items-center gap-2 text-sm hover:border-goshine-orange/50 transition-colors"
              >
                <FontAwesomeIcon icon={faInstagram} className="text-goshine-orange" />
                @goshine.ea
              </ExternalLink>
              <ExternalLink 
                href={TIKTOK} 
                className="glass-effect px-4 py-2.5 flex items-center gap-2 text-sm hover:border-goshine-orange/50 transition-colors"
              >
                <FontAwesomeIcon icon={faTiktok} className="text-goshine-orange" />
                @goshine.ea
              </ExternalLink>
            </div>
          </div>

          {/* Image */}
          <div className="relative order-1 lg:order-2">
            <div className="absolute inset-0 bg-gradient-to-r from-goshine-orange/20 to-goshine-purple-light/20 rounded-2xl sm:rounded-3xl blur-3xl" />
            <div className="relative glass-effect p-6 sm:p-8 lg:p-12 rounded-2xl sm:rounded-3xl">
              <img src={SYMBOL} alt="GoShine" className="w-full max-w-xs lg:max-w-sm mx-auto" />
              <div className="absolute -bottom-3 -right-3 sm:-bottom-4 sm:-right-4 lg:-bottom-5 lg:-right-5 bg-goshine-orange text-white px-4 py-2 sm:px-6 sm:py-3 lg:px-8 lg:py-4 rounded-xl sm:rounded-2xl font-bold shadow-lg text-sm sm:text-base lg:text-lg">
                Desde 2019
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
